// 탭 중앙 설정 — App.js, SuperAdmin.js 공유
export const TAB_CONFIG = [
  { key: 'billing',    label: '📱 고지서' },
  { key: 'monthly',    label: '📈 사용량' },
  { key: 'ble_bt',     label: '🔵 블루투스키' },
  { key: 'ble_nfc',    label: '📱 NFC키' },
  { key: 'ble_remote', label: '🔗 원격키' },
  { key: 'ble_log',    label: '🚪 출입로그' },
  { key: 'contract',   label: '📄 서류관리' },
];

// 출입관리 탭 키 목록 (App.js에서 ble 탭 표시 여부 판단용)
export const BLE_KEYS = ['ble_bt', 'ble_nfc', 'ble_remote', 'ble_log'];
